import configByPhase from './config-NODE_ENV'

const defaultConfig = {
  BASE_URL: 'https://api-gw-bankid.line-beta.me',
  CLIENT_ENV: 'beta',
  ASSET_PATH: process.env.ASSET_PATH,
  APP_SCHEME: 'lbidb://',
  OFFICIAL_HOMEPAGE: 'https://hybrid.linebank.co.id/linebank-app',
  APP_LINK: 'https://hybrid.linebank.co.id/',
}

const configs = {
  ...defaultConfig,
  ...configByPhase,
}

export default configs
